import { render, staticRenderFns } from "./Configuracion.vue?vue&type=template&id=f2c0b1f2&scoped=true&"
import script from "./Configuracion.vue?vue&type=script&lang=js&"
export * from "./Configuracion.vue?vue&type=script&lang=js&"
import style0 from "./Configuracion.vue?vue&type=style&index=0&id=f2c0b1f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c0b1f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCard,VCardText,VIcon,VSpacer,VTab,VTabItem,VTabs,VToolbar,VToolbarTitle})
